import React from 'react';

export type TProps = {
  template: string;
  noitems: {
    title: string;
    description: string;
    image: {
      url: string;
    };
    channel: string;
    resolution: string;
  };
};

export default function NoMoreItems({ template, noitems }: TProps) {
  const prefixTemplateClass = `vitrine-template${template}`;

  return (
    <div className={`${prefixTemplateClass}__noitems`}>
      <img
        src={noitems.image.url}
        className={`${prefixTemplateClass}__noitems--image`}
        alt={noitems.title}
      />
      <h2 className={`${prefixTemplateClass}__noitems--title`}>
        {noitems.title}
      </h2>
      <p className={`${prefixTemplateClass}__noitems--description`}>
        {noitems.description}
      </p>
    </div>
  );
}
